"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
require("./ShippingForm.less");
var _utils = require("../../utils");
var _ = require("./..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = _typography.default.Title;
var UsaStates = _utils.UsaStatesUtils.UsaStates;
var ShippingForm = function ShippingForm(props) {
  var permanentAddress = props.permanentAddress,
    savedShippingAddress = props.savedShippingAddress,
    onSubmit = props.onSubmit,
    form = props.form,
    loading = props.loading,
    submitText = props.submitText;
  var getFieldDecorator = form.getFieldDecorator,
    getFieldsError = form.getFieldsError;
  var _ref = permanentAddress || {},
    homeAddress = _ref.homeAddress,
    homeAddressLineTwo = _ref.homeAddressLineTwo,
    city = _ref.city,
    state = _ref.state,
    zipCode = _ref.zipCode;
  var _ref2 = savedShippingAddress || {},
    shippingAddress = _ref2.shippingAddress,
    shippingAddressLineTwo = _ref2.shippingAddressLineTwo,
    shippingCity = _ref2.shippingCity,
    shippingState = _ref2.shippingState,
    shippingZipCode = _ref2.shippingZipCode;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, values) {
      if (!err) {
        onSubmit({
          shippingAddress: values
        });
      }
    });
  };
  var submitDisabled = function submitDisabled(fieldsError) {
    return Object.keys(fieldsError).some(function (field) {
      return fieldsError[field];
    }) || loading;
  };
  var addressDecorator = getFieldDecorator('shippingAddress', {
    initialValue: shippingAddress || homeAddress,
    rules: [{
      required: true,
      message: 'Please provide your shipping address.'
    }, {
      max: 35,
      message: '35 characters max'
    }]
  });
  var addressTwoDecorator = getFieldDecorator('shippingAddressLineTwo', {
    initialValue: shippingAddress ? shippingAddressLineTwo : homeAddressLineTwo
  });
  var cityDecorator = getFieldDecorator('shippingCity', {
    initialValue: shippingCity || city,
    rules: [{
      required: true,
      message: 'Please enter your city.'
    }, {
      min: 2,
      message: 'City must contain at least 2 characters.'
    }]
  });
  var zipDecorator = getFieldDecorator('shippingZipCode', {
    initialValue: shippingZipCode || zipCode,
    rules: [{
      required: true,
      message: 'Please enter your zip code.'
    }, {
      pattern: _utils.zipCodeRegex,
      message: 'Zip code must contain 5 digits'
    }]
  });
  return /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit,
    className: "ShippingForm"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(Title, {
    level: 4
  }, "Shipping Information")), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, addressDecorator( /*#__PURE__*/_react.default.createElement(_input.default, {
    type: "text",
    name: "address",
    placeholder: "Address",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, addressTwoDecorator( /*#__PURE__*/_react.default.createElement(_input.default, {
    type: "text",
    name: "address_two",
    placeholder: "Apt",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, cityDecorator( /*#__PURE__*/_react.default.createElement(_input.default, {
    type: "text",
    name: "city",
    placeholder: "City",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('shippingState', {
    initialValue: shippingState || state,
    rules: [{
      required: true,
      message: 'Please select your state.'
    }]
  })( /*#__PURE__*/_react.default.createElement(_.LegacySelectInput, {
    placeholder: "State",
    showSearch: true,
    size: "large",
    options: UsaStates.map(function (item) {
      return {
        key: item.abbreviation,
        value: item.abbreviation,
        label: item.name
      };
    })
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, zipDecorator( /*#__PURE__*/_react.default.createElement(_input.default, {
    type: "text",
    name: "zipCode",
    placeholder: "Zip code",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    htmlType: "submit",
    size: "large",
    block: true,
    disabled: submitDisabled(getFieldsError())
  }, submitText)));
};
var _default = _form.default.create({
  name: 'ShippingForm'
})(ShippingForm);
exports.default = _default;